import React, { type ReactNode, Suspense } from 'react';

const LazyAuthenticatedLayout = React.lazy(() =>
  import('@/layouts/AuthenticatedLayout').then((module) => ({
    default: module.AuthenticatedLayout
  }))
);

/**
 * The one way to wrap a page in the authenticated shell. React keeps a layout mounted across
 * Inertia navigations only while the root element type stays the same — a page that builds
 * its own `<AuthenticatedLayout>` element (or wraps it in another component) introduces a new
 * root type, and crossing between it and any other page remounts the whole shell, which is
 * visible as the sidebar flashing. Routing every page through this helper keeps a single
 * element identity, so the shell — sidebar included — survives navigation.
 *
 * The lazy import is deliberate: public pages must not pull the admin shell into their bundle.
 */
export function authenticatedPage(
  page: ReactNode,
  options: { fullWidthMain?: boolean } = {}
): ReactNode {
  return (
    <Suspense fallback={<div className="h-screen bg-background" />}>
      <LazyAuthenticatedLayout fullWidthMain={options.fullWidthMain}>
        {page}
      </LazyAuthenticatedLayout>
    </Suspense>
  );
}
